<script setup lang="ts">
import {useExtraScript} from "~/composables/useExtraScrtipts";

const headData = useExtraScript();
useHead(headData)
</script>

<template>
  <div class="layout">
    <AppNavbar/>

    <div class="mb-auto">
      <slot></slot>
    </div>

    <AppFooter/>
  </div>
</template>

<style scoped lang="scss">
.layout {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 100vh;
}
</style>
